<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>一次性授權年度</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>

                  <td>姓名</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid.gridDatas">
            <tbody>
              <tr>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('name', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('idn', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('goV_NAME', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('oneSyear', Sort);
                          }
                        "
                      >
                        一次性授權年度</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody v-if="grid.gridDatas && grid.gridDatas.length > 0">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="取消"
                        @click="btnCancel(data)"
                      />
                    </td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>{{ data.goV_NAME }}</td>
                    <td>{{ data.oneSyear }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <!-- 編輯 -->
    <Modal
      v-model="modal.show"
      :title="modal.title"
      :modalStyle="{ 'max-width': '1000px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>
                  取消授權書<a
                    :href="
                      'data:' +
                      modal.PreData.cancelFileType +
                      ';base64,' +
                      modal.PreData.cancelFileString
                    "
                    :download="modal.PreData.cancelFileName"
                  >
                    {{ modal.PreData.cancelFileName }}
                  </a>
                </td>
                <td>
                  <input type="file" accept=".pdf" @change="onFileChange" />
                  <input type="checkbox" v-model="modal.form.SingleFLAG" />
                  <label>單親撫養</label>
                  <!-- <input type="submit" class="btn" value="上傳取消授權書" /> -->
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <!-- <input type="submit" class="btn" value="存檔" />
                      <input type="submit" class="btn" value="重填" /> -->
                      <input
                        type="submit"
                        class="btn"
                        value="查看歷程"
                        @click="btnHistoryModal()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="information">
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>操作</th>
                  <th>一次性授權年度</th>
                  <th>姓名</th>
                  <th>身分證統一編號</th>
                  <th>關係</th>
                  <th>授權狀態</th>
                  <th>授權時間</th>
                  <th>授權方式</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in modal.grid" :key="index">
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="取消授權"
                      @click="btnCancelAuth(data)"
                      :disabled="!data.isCancelBtn"
                    />
                  </td>
                  <td>{{ data.syear }}</td>
                  <td>{{ data.familyName }}</td>
                  <td>{{ data.familyIdn }}</td>
                  <td>{{ data.familyTitle }}</td>
                  <td>{{ data.status }}</td>
                  <td>{{ data.authDate }}</td>
                  <td>{{ data.warrantClass }}</td>
                </tr>
                <tr v-if="!grid">
                  <td colspan="8" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </Modal>
    <!-- 歷程查詢 -->
    <HistoryModal
      v-model="historyModal.show"
      :title="historyModal.title"
      :modalStyle="{ 'max-width': '1000px' }"
    >
      <div class="information">
        <table width="100%">
          <tbody>
            <tr v-for="(data, index) in historyModal.grid.files" :key="index">
              <td>
                授權書：<a
                  :href="data.fileType + ',' + data.fileString"
                  :download="data.fileName"
                >
                  {{ data.fileName }}
                </a>
                &nbsp;
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>年度</th>
                  <th>姓名</th>
                  <th>身分證字號</th>
                  <th>關係</th>
                  <th>狀態</th>
                  <th>授權時間</th>
                  <th>執行動作</th>
                  <th>異動時間</th>
                  <th>異動人員</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in historyModal.grid.logs"
                  :key="index"
                >
                  <td>{{ data.syear }}</td>
                  <td>{{ data.familyName }}</td>
                  <td>{{ data.familyIdn }}</td>
                  <td>{{ data.familyTitle }}</td>
                  <td>{{ data.status }}</td>
                  <td>{{ data.authDate }}</td>
                  <td>{{ data.warrantClass }}</td>
                  <td>{{ data.updateDateTime }}</td>
                  <td>{{ data.updateUserId }}</td>
                </tr>
                <tr
                  v-if="
                    !historyModal.grid.logs || !historyModal.grid.logs.length
                  "
                >
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 查詢結果結束-->
      </div>
    </HistoryModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.show = false">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  M106_SearchGrid,
  M106_ReSearchGrid,
  M106_SearchGrid2,
  M106_SearchGrid3,
  M106_CancelAuthOne,
} from "@/service/api.js";

export default {
  name: "M106",
  data: function () {
    return {
      pageData: {
        MenuIndex: 5,
        MenuName: "",
        PrgName: "M106",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        syear: "",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        syears: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
      },
      grid: {},
      modal: {
        form: {
          SingleFLAG: false,
          file: {
            oneSeq: 0,
            fileName: "",
            fileType: "",
            fileString: "",
          },
          uploadFile: "",
        },
        grid: [],
        show: false,
        PreData: {},
        title: "M106取消一次性授權-編輯",
      },
      historyModal: {
        show: false,
        title: "授權歷程查詢",
        grid: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Modal: VueModal,
    HistoryModal: VueModal,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        SYEAR: self.form.syear,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: self.form.jobGovCheck,
        NAME: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M106_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "oneSyear";
          self.Sort = "DESC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        SYEAR: self.form.syear,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: self.form.jobGovCheck,
        NAME: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      M106_ReSearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    btnClear: function () {
      const self = this;
      self.form = {
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        syear: "",
        currentpage: 1,
        pagesize: 10,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    btnCancel: function (data) {
      const self = this;
      debugger;
      self.modal.form.uploadFile = "";
      self.modal.form.file.fileName = "";
      self.modal.form.file.fileString = "";
      self.modal.form.file.fileType = "";
      let postData = {
        oneSeq: data.oneSeq,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "取消",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M106_SearchGrid2(postData).then((rData) => {
        self.modal.grid = rData.returnObject;
        self.modal.show = true;
        self.modal.PreData = data;
        self.modal.PreData.cancelFileType = self.modal.grid[0].fileType;
        self.modal.PreData.cancelFileName = self.modal.grid[0].fileName;
        self.modal.PreData.cancelFileString = self.modal.grid[0].fileString;
      });
    },
    //modal

    //取消授權
    btnCancelAuth: function (data) {
      const self = this;
      if (
        (self.modal.form.file.fileName === "" &&
        self.modal.form.file.fileString === "")
      ) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["請先上傳取消授權書!"];
        return;
      } else {
        let postData = {
          oneSeq: self.modal.PreData.oneSeq,
          pkno: data.pkno,
          singleFlag: self.modal.form.SingleFLAG,
          fileName: self.modal.form.file.fileName,
          fileType: self.modal.form.file.fileType,
          fileString: self.modal.form.file.fileString,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁-取消一次性",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.modal.form.uploadFile);
        formData.append("oneSeq", self.modal.PreData.oneSeq);
        formData.append("pkno", data.pkno);
        formData.append("singleFlag", self.modal.form.SingleFLAG);

        formData.append("LogInfo.Id", self.loginInfo.id);
        formData.append("LogInfo.PrgCode", self.pageData.PrgName);
        formData.append("LogInfo.Token", self.loginInfo.token);
        formData.append("LogInfo.ActCd", "第二頁-取消一次性");
        formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
        M106_CancelAuthOne(formData).then((rData) => {
          if (rData.result) {
            M106_SearchGrid2({
              oneSeq: self.modal.PreData.oneSeq,
              LogInfo: {
                Id: self.loginInfo.id,
                PrgCode: self.pageData.PrgName,
                ActCd: "取消",
                ServiceUnit: self.pageData.ServiceUnit,
                Token: self.loginInfo.token,
              },
            }).then((rrData) => {
              self.modal.grid = rrData.returnObject;
              self.modal.PreData.cancelFileType = self.modal.grid[0].fileType;
              self.modal.PreData.cancelFileName = self.modal.grid[0].fileName;
              self.modal.PreData.cancelFileString =
                self.modal.grid[0].fileString;
            });
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["取消授權失敗!"];
          }
        });
      }
    },
    //查詢歷程
    btnHistoryModal: function () {
      const self = this;
      let postData = {
        idn: self.modal.PreData.idn,
        govCode: self.modal.PreData.goV_CODE,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢歷程",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M106_SearchGrid3(postData).then((rData) => {
        if (rData.result) {
          self.historyModal.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
      self.historyModal.show = true;
    },
    onFileChange: function (event) {
      const self = this;
      let file = event.target.files[0];
      self.modal.form.uploadFile = file;
      self.modal.form.file = {
        oneSeq: 0,
        fileName: file.name,
        fileType: file.type,
        fileString: "",
      };
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.modal.form.file.fileType = reader.result.split(",")[0];
        self.modal.form.file.fileString = reader.result.split(",")[1];
      };
      reader.onerror = function (error) {
        console.log("取消一次性授權檔案錯誤: ", error);
      };
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
